import { useEffect, useState } from "react";
import ReactModal from "react-modal";
import FreshmanConfigurationCreate from "./components/freshmanConfigurationCreate";
import { connect, useDispatch } from "react-redux";
import { IGetConfiguration } from "../../../../../models/freshman/configuration";
import {
  deleteFreshmanConfiguration,
  getAllFreshmanCofiguration,
  getFreshmanConfiguration,
} from "../../../../../action/freshman/configurationActionCreator";
import {
  getAllStudentType,
  getColleges,
} from "../../../../../action/common/commonActionCreator";
import FreshmanConfigurationEdit from "./components/freshmanConfigurationEdit";
import {
  setConfiguration,
  setConfigurations,
} from "../../../../../store/slices/freshman/configurationSlice";
import LoaderSpinner from "../../../../../common-components/loader";
import { NavLink } from "react-router-dom";
import { FRESHMAN_ROUTER_URL } from "../../../../../constants/routerUrl";
import { getAllMainStepsKeyValuePair } from "../../../../../action/freshman/mainstepActionCreator";
import { getAllSubStepsKeyValuePair } from "../../../../../action/freshman/subStepActionCreator";
import SweetAlert from "react-bootstrap-sweetalert";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import FreshmanConfigurationView from "./components/freshmanConfigurationView";

const FreshmanConfigurationIndex = (props: IGetConfiguration) => {
  const {
    getConfiguration,
    configurations,
    colleges,
    studentTypes,
    getAllStudentType,
    getCampus,
    freshman,
    getFreshmanData,
    getMainSteps,
    getSubSteps,
    deleteConfiguration,
    mainSteps,
    subSteps,
  } = props;
  const [createModalOpen, setCreateModalOpen] = useState<boolean>(false);
  const [viewModalOpen, setViewModalOpen] = useState<boolean>(false);
  const [editModalOpen, setEditModalOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [initialLoading, setInitialLoading] = useState<boolean>(true);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isDelete, setIsDelete] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);

  const dispatch = useDispatch();

  const handleCreateClose = () => {
    setCreateModalOpen(false);
  };

  const handleViewClose = () => {
    setViewModalOpen(false);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
  };

  const getConfigurationDetails = async () => {
    setInitialLoading(true);
    try {
      await getConfiguration();
    } finally {
      setInitialLoading(false);
    }
  };

  useEffect(() => {
    getConfigurationDetails();
    getAllStudentType();
    getCampus();
    getMainSteps();
    getSubSteps();
    return () => {
      dispatch(setConfiguration([]));
      dispatch(setConfigurations([]));
    };
  }, []);

  const handelEditClick = async (id: number | null) => {
    setEditModalOpen(true);
    if (id != null) {
      setLoading(true);
      await getFreshmanData(id);
    }
    setLoading(false);
  };

  const handleViewClick = async (id: number | null) => {
    setViewModalOpen(true);
    if (id != null) {
      setLoading(true);
      await getFreshmanData(id);
    }
    setLoading(false);
  };

  const deleteItem = (id: number | 0) => {
    setIsDelete(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isDelete === true) {
      setShowAlert(false);
      setIsDelete(false);
      deleteConfiguration(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsDelete(false);
      getConfigurationDetails();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Configuration</h2>
          <button
            onClick={() => setCreateModalOpen(true)}
            className="btn btn-primary"
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add Configuration
          </button>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-3">
          {initialLoading ? (
            <LoaderSpinner />
          ) : configurations && configurations.length > 0 ? (
            configurations.map((c) => (
              <li
                className="admin-card-configuration"
                style={{
                  pointerEvents: !c.isActive ? "none" : "auto",
                  opacity: !c.isActive ? 0.5 : 1,
                }}
              >
                <div className="top">
                  <div className="me-2">
                    <strong>Version : </strong>
                    {c.versionId}
                  </div>
                  <div className="btn-flex btn-flex-configuration">
                    <a
                      className="btn-view"
                      onClick={() => handleViewClick(c.id)}
                    >
                      <img src="/assets/images/icon/eye-wh.svg" alt="" />
                    </a>
                    <a
                      className="btn-edit"
                      onClick={() => handelEditClick(c.id)}
                    >
                      <img src="/assets/images/icon/edit-wh.svg" alt="" />
                    </a>
                    <button
                      className="btn-delete"
                      onClick={() => deleteItem(c.id ?? 0)}
                    >
                      <img src="/assets/images/icon/trash-wh.svg" alt="" />
                    </button>
                  </div>
                </div>
                <div className="btm">
                  <a data-bs-toggle="modal" data-bs-target="#viewdetails">
                    <h2>
                      Program level:{" "}
                      {studentTypes?.find((st) => st.id == c.studentType)?.name}
                    </h2>
                    <h2>
                      International student: {c.isInternational ? "yes" : "No"}
                    </h2>
                    <h2>
                      University Management:{" "}
                      {colleges?.find((co) => co.id == c.collegeId)?.name}
                    </h2>
                  </a>
                </div>
              </li>
            ))
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>

      <ReactModal
        isOpen={createModalOpen}
        onRequestClose={handleCreateClose}
        className="react-modal-content full-width"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <FreshmanConfigurationCreate
          setShowCreate={handleCreateClose}
          getAllConfiguration={() => getConfigurationDetails()}
        />
      </ReactModal>
      {loading ? (
        <LoaderSpinner />
      ) : (
        <>
          <ReactModal
            isOpen={editModalOpen}
            onRequestClose={handleEditClose}
            className="react-modal-content full-width"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <FreshmanConfigurationEdit
              setShowEdit={handleEditClose}
              freshmanData={freshman}
              getAllConfiguration={() => getConfigurationDetails()}
            />
          </ReactModal>

          <ReactModal
            isOpen={viewModalOpen}
            onRequestClose={handleViewClose}
            className="react-modal-content"
            overlayClassName="react-modal-overlay"
            shouldCloseOnOverlayClick={false}
          >
            <FreshmanConfigurationView
              setShowView={handleViewClose}
              configurationData={freshman}
              getAllConfiguration={() => getConfigurationDetails()}
            />
          </ReactModal>
        </>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isDelete}
        onCancel={() => {
          setShowAlert(false);
          setIsDelete(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isDelete ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getConfiguration: () => getAllFreshmanCofiguration(),
  getCampus: getColleges,
  getAllStudentType: getAllStudentType,
  getFreshmanData: (id: number) => getFreshmanConfiguration(id),
  getMainSteps: getAllMainStepsKeyValuePair,
  getSubSteps: getAllSubStepsKeyValuePair,
  deleteConfiguration: (studentCategoryId: number, callBack: Function) =>
    deleteFreshmanConfiguration(studentCategoryId, callBack),
};

function mapStateToProps(state: any) {
  return {
    configurations: state.freshmanConfiguration.freshmanConfigurations,
    studentTypes: state.common.studentType,
    colleges: state.common.colleges,
    freshman: state.freshmanConfiguration.freshmanConfiguration,
    mainSteps: state.mainStep.keyValuePair,
    subSteps: state.subStep.keyValuePair,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreshmanConfigurationIndex);
